export default "__VITE_ASSET__mI8Kl3Vh__"